import {
  lighten,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { ReactElement } from 'react';
import { theme } from '@theguarantors/tg-package-material-ui';

interface Props {
  open: boolean;
  text?: string;
  displayText?: ReactElement;
  action: () => void;
  icon?: JSX.Element;
  ariaLabel?: string;
  selected?: boolean;
  disabled?: boolean;
  outlined?: boolean;
}

const SideMenuItem = ({
  open,
  text,
  displayText,
  action,
  icon,
  ariaLabel,
  selected,
  disabled,
  outlined,
}: Props) => {
  const themeAsAny = theme as any;

  return (
    <ListItem
      disablePadding
      sx={{
        minWidth: '48px',
      }}
    >
      <Tooltip arrow title={text} disableHoverListener={open || !text} placement="right">
        <ListItemButton
          onClick={action}
          className={open ? 'list-item-button-open' : 'list-item-button-close'}
          disabled={disabled}
          sx={{
            outline: outlined ? '1px solid white' : 'none',
            justifyContent: !icon && outlined ? 'center' : 'flex-start',
            alignItems: 'center',
            padding: '12px',
            borderRadius: '10px',
            margin: open ? '2px 12px' : '2px 8px',
            height: '50px',
            textAlign: icon ? 'left' : 'center',
            backgroundColor: lighten(themeAsAny.palette.blue[950], selected ? 0.2 : 0),
            [':hover']: {
              backgroundColor: lighten(themeAsAny.palette.blue[950], 0.1),
            },
            [':active']: {
              backgroundColor: lighten(themeAsAny.palette.blue[950], 0.2),
            },
          }}
          aria-label={ariaLabel ?? text}
        >
          {icon && (
            <ListItemIcon
              sx={{
                justifyContent: text || !open ? 'center' : 'flex-end',
                alignItems: 'center',
                minWidth: 'unset',
                height: '24px',
                width: '24px',
                ['svg']: {
                  fontSize: '22px',
                },
              }}
            >
              {icon}
            </ListItemIcon>
          )}

          {text ? (
            <Collapse
              in={open}
              orientation="horizontal"
              timeout={300} // Adjust the duration of the animation as needed
              sx={{
                paddingLeft: open && icon ? '24px' : '0px',
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                transition: 'all 0.3s linear',
              }}
            >
              <ListItemText
                primary={displayText ?? text}
                primaryTypographyProps={{
                  color: disabled ? 'text.disabled' : 'white',
                }}
                sx={{
                  lineHeight: '24px',
                }}
              />
            </Collapse>
          ) : null}
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
};

export default SideMenuItem;
